import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linejoin": "round",
      d: "M6.217 13.607A6.007 6.007 0 016 12c0-.556.076-1.095.217-1.607L4.004 9.117a8.5 8.5 0 000 5.768l2.213-1.277zM7.719 16.204l-2.215 1.278a8.5 8.5 0 004.996 2.884v-2.555a5.994 5.994 0 01-2.781-1.607zM17.782 10.393l2.214-1.277a8.496 8.496 0 010 5.768l-2.213-1.277c.141-.512.217-1.05.217-1.607 0-.556-.076-1.095-.218-1.607zM18.496 6.518L16.28 7.796A5.994 5.994 0 0013.5 6.19V3.633a8.5 8.5 0 014.996 2.885zM13.5 17.811a5.994 5.994 0 002.781-1.607l2.215 1.278a8.498 8.498 0 01-4.996 2.885V17.81z"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M6.612 7.149a7.25 7.25 0 013.88-2.24"
    })
  ]))
}